import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../../rootSelectors';
import VocabBDView from '../../VocabBDView';
import AvatarView from '../../../../common/avatar/avatarView';
import withAvatar from '../../../../common/avatar/withAvatar';
import { VOCAB_AUDIO_INSTRUCTIONS } from '../../../vocabConstants';
import { QUESTIONS } from '../../../../constants/assessmentItemType';
import { unmountScreen } from '../../../../common/screen/screenActions';
import { onResponseSelect } from '../../../vocabActions';
import { narrateStimulus, resetSelectedIndex } from '../../../../common/questions/questionsActions';
import { fetchVocabBDContent } from '../../vocabBDActions';
import { narrateQuestionsScreen, onNextQuestionButtonClick } from './VocabBDQuestionsActions';
import { getQuestionIndex } from '../../../../common/utils/urlParsers';
import { narrateReset, stopAudio } from '../../../../common/audio/audioActions';
import { getAvatarPosition } from '../../../../common/alex/AlexUtils';

const mapStateToProps = (state, ownProps) => {
    const questionIndex = getQuestionIndex(ownProps.match.params);
    return {
        isDataFetched: selectors.getIsVocabBDDataFetched(state),
        stimulus: selectors.getVocabBDStimulusInfo(state, QUESTIONS, questionIndex - 1),
        possibleResponses: selectors.getVocabBDPossibleResponses(
            state,
            QUESTIONS,
            questionIndex - 1,
        ),
        isScreenBlocked: selectors.getIsScreenBlocked(state),
        isStimulusPlaying: selectors.getIsStimulusPlaying(state),
        isNextButtonActive: selectors.getIsNextButtonActive(state),
        selectedResponse: selectors.getSelectedIndex(state),
        questionIndex,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const questionIndex = getQuestionIndex(ownProps.match.params);

    return {
        fetchContent: () => {
            dispatch(fetchVocabBDContent());
        },
        narrateScreen: stimulusAudio =>
            dispatch(narrateQuestionsScreen(questionIndex - 1, stimulusAudio)),
        playStimulus: stimulusAudio => dispatch(narrateStimulus(stimulusAudio)),
        selectResponse: response => dispatch(onResponseSelect(response)),
        onNext: response => dispatch(onNextQuestionButtonClick(response, questionIndex)),
        cleanup: () => {
            dispatch(stopAudio());
            dispatch(narrateReset());
            dispatch(resetSelectedIndex());
            dispatch(unmountScreen());
        },
    };
};

const avatarMapStateToProps = state => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.LOWER_LEFT,
    };
    const position = getAvatarPosition(positionConfig);
    return {
        position,
        animateAlex: true,
        instructions:
            VOCAB_AUDIO_INSTRUCTIONS[selectors.getCurrentLanguage(state)]
                .vocabBDPracticeInstructionStart,
    };
};

const VocabBDQuestionsContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(VocabBDView);

export default VocabBDQuestionsContainer;
